<script>
  import Button from '@components/buttons/button.svelte'
  import { X } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { title, description, buttonProps = {}, Icon, iconProps = {}, onClose, class: className } = $props()
</script>

<div class={cn("border border-gray-200 rounded-md shadow-lg p-3", className)}>

  <!-- A container for the icon and onClose button -->
  {#if Icon || onClose}
    <div class="flex items-center justify-between mb-4">
      {#if Icon}
        <Icon size={20} {...iconProps} />
      {/if}
      {#if onClose}
        <Button variant="naked" onclick={onClose} Icon={X} />
      {/if}
    </div>
  {/if}

  <div class="flex flex-col gap-2">
    <h4 class="text-[14px] font-semibold text-gray-800 leading-none">{title}</h4>
    <p class="text-smaller text-gray-500/90">{description}</p>
    <Button variant="bold" class="w-full justify-center" {...buttonProps} />
  </div>
</div>